module.exports = __webpack_public_path__ + "static/img/tbshop.b43717a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tbshop.png
// module id = kCyl
// module chunks = 13